import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import UploadFileRequestSignatureView from "./view";
import { uploadFileManual } from "../../../../services/FileUploadService";
import LoadingComponent from "../../../../components/loading";
import { getDetailFolderList } from "../../../../store/document/actions";

export function UploadFileRequestSignature(props) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const acceptedFileTypes = ".pdf";
  const [uploaded, setUploaded] = React.useState(false);
  const [messageText, setMessageText] = React.useState("Getting Explorer Data");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notify = (msj, event) => toast[event](msj);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setSelectedFiles(acceptedFiles);
      setShowUpload(true);
    } else {
      setShowUpload(false);
      notify(
        "Incorrect document type. We can only process PDF files.",
        "error"
      );
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptedFileTypes,
  });

  const saveUpload = () => {
    selectedFiles.map((file) => {
      setUploaded(true);
      setMessageText("Uploading document");
      uploadFileManual(file, true, null, null, true)
        .then((response) => {
          setUploaded(false);
          notify(file.name + " u" + "ploaded", "success");
          setShowUpload(false);
          setSelectedFiles([]);
        })

        .catch((err) => {
          setUploaded(false);
          toast.error(err?.response?.data?.error?.messages[0].message);
        })
        .finally(() => {
          setMessageText("Getting Explorer Data");
          dispatch(
            getDetailFolderList(
              {
                parentArchiveId: "",
                page: props.page,
                pageSize: props.pageSize,
              },
              navigate
            )
          );
        });
    });
  };

  const closeUpload = useCallback(() => {
    setShowUpload(false);
    setSelectedFiles([]);
  }, []);

  useEffect(() => {
    if (props.closeUp) {
      setSelectedFiles([]);
    }
  }, [props.closeUp]);

  return (
    <>
      <UploadFileRequestSignatureView
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        selectedFiles={selectedFiles}
        closeUpload={closeUpload}
        showUpload={showUpload}
        saveUpload={saveUpload.bind(this)}
      />
      <LoadingComponent show={uploaded === true} text={messageText} />
      <ToastContainer autoClose={3000} />
    </>
  );
}

export default UploadFileRequestSignature;
